import React from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import SideNav from '../../shared/Sidenav';
import '../../../css/preAdvise/PreAdvise.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import arrow from '../../../assets/images/drpdwnArrow.svg';
import DeleteModal from '../../shared/DeleteRoleModal';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import PreviewModal from '../../shared/PreviewDocument';
import SuccessModal from '../../shared/SuccessModal';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { workflowtxnAdmin, utilityBaseURL } from '../../../Services/config/apiGateway';
import { GETPROXYDETAIL_ENDPOINT, DOWNLOAD_ENDPOINT, PROXYDOCUMENTACTION_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import Cookies from 'cookies-js';
import Loader from 'react-loader';
import { store } from '../../../redux/_helpers/store';
import {successLoader,} from '../../../redux/_actions/loader.action';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

let viewOnly = false;
var pageDisable = false;
var loaderTime = false;
const urlPath = utilityBaseURL + DOWNLOAD_ENDPOINT + "?documentPath=";
var decodeProxyImage = "";
let hasOpenImagePreview = false;
class PreAdvise extends React.Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            actiondropdown: [false],
            action: [],
            details: [],
            allProxyDetails: [],
            currentPage: 1,
            todosPerPage: 4,
            search: "",
            searchlength: 0,
            detailsClosed1: [],
            openSide: true,
            closedSide: false,
            hasOpenDelete: false,
            detailsClosed: [],
            currentClosedPage: 1,
            todosClosedPerPage: 4,
            filteredIndexOpen: [0, 1, 2, 3, 4, 5, 6],
            confirmedHasOpen: false,
            revokeIndex: '',
            actionIndex: '',
        }
        this.handleOpenClick = this.handleOpenClick.bind(this);
        this.handleOpenPrevious = this.handleOpenPrevious.bind(this);
        this.handleClosedClick = this.handleClosedClick.bind(this);
        this.handleClosedPrevious = this.handleClosedPrevious.bind(this);
        this.handlechange = this.handlechange.bind(this);
        this.handleOpenSide = this.handleOpenSide.bind(this);
        this.handleClosedSide = this.handleClosedSide.bind(this);
        this.onSearchOpen = this.onSearchOpen.bind(this);
    }
    ActionData = [{ name: "Approve" }, { name: "Reject" }]
    onCloseDeleteModal = () => {
        this.setState({ hasOpenDelete: false });
    }
    confirmDelete = (index) => {
        console.log(this.state.detailsClosed1[this.state.revokeIndex])
        ApiCall(
            'POST',
            workflowtxnAdmin + PROXYDOCUMENTACTION_ENDPOINT,
            {
                "action": "revoke",
                "proxyDocumentId": this.state.detailsClosed1[this.state.revokeIndex].proxyDocumentId
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ confirmedHasOpen: true, hasOpenDelete: false });
                }
            }
            else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    onRevoke = (index) => {
        this.setState({ hasOpenDelete: true, revokeIndex: index });
    }
    handleOpenClick() {
        if (this.state.currentPage < Math.ceil(this.state.filteredIndexOpen.length / this.state.todosPerPage)) {
            this.setState({
                currentPage: this.state.currentPage + 1
            });
        }
    }
    handleOpenPrevious() {
        if (this.state.currentPage >= 2) {
            this.setState({
                currentPage: this.state.currentPage - 1
            });
        }
    }
    handleClosedClick() {
        if (this.state.currentClosedPage < Math.ceil(this.state.detailsClosed1.length / this.state.todosClosedPerPage)) {
            this.setState({
                currentClosedPage: this.state.currentClosedPage + 1
            });
        }
    }
    handleClosedPrevious() {
        if (this.state.currentClosedPage >= 2) {
            this.setState({
                currentClosedPage: this.state.currentClosedPage - 1
            });
        }
    }
    handlechange = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value.length
        }, () => {
            this.onSearchOpen();
        });
        if (this.state.openSide == true) {
            this.setState({ currentPage: 1 })
        }
        else if (this.state.closedSide == true) {
            this.setState({ currentClosedPage: 1 })
        }
    };
    handleOpenSide = () => {
        this.setState({
            openSide: true,
            closedSide: false,
            filteredIndexOpen: this.state.details.map((proxy, openIndex) => openIndex)
        });
        document.getElementById('open').style.borderBottom = "3px solid #a7a7a7";
        document.getElementById('closed').style.borderBottom = "none";
    };
    handleClosedSide = () => {
        this.setState({
            openSide: false,
            closedSide: true
        });
        document.getElementById('closed').style.borderBottom = "3px solid #a7a7a7";
        document.getElementById('open').style.borderBottom = "none";
    };
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            let actiondropdown = this.state.actiondropdown;
            actiondropdown[this.state.actionIndex] = false;
            this.setState({ actiondropdown: actiondropdown });
        }
    };
    selectAction = (e, index, rowindex, f) => {
        console.log(f, "f")
        let action = this.state.action;
        action[rowindex] = e.target.innerText;
        console.log(rowindex, 'row index')
        this.setState({ action: action }, () => {
            console.log('action array - ', this.state.action);
        });
        let a = this.state.actiondropdown;
        a[rowindex] = false
        this.setState({ actiondropdown: a })
    }
    disabledConfirmed = (index) => {
        return this.state.action[index]?.length > 0
    };
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 11) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        ApiCall(
            'GET',
            workflowtxnAdmin + GETPROXYDETAIL_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ allProxyDetails: data }, () => {
                        let details = [];
                        let detailsClosed = [];
                        this.state.allProxyDetails.forEach(sd => {
                            console.log(sd.action, "sd")
                            if (sd.action == "Approved" || sd.action == "Rejected" || sd.action == "Revoked") {
                                console.log("if")
                                detailsClosed.push(sd);
                            }
                            else {
                                console.log("else")
                                details.push(sd);
                                console.log(sd, details, this.state.details, this.state.filteredIndexOpen)
                            }
                        });
                        console.log('ep--', detailsClosed, details, this.state.detailsClosed1, this.state.filteredIndexOpen);
                        this.setState({ details: details, detailsClosed: detailsClosed, filteredIndexOpen: details.map((proxy, openIndex) => openIndex) })
                    })
                }
            }
            else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    getDate = (timeStamp) => {
        let date = new Date(timeStamp).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    onPreviewProxyDocument = (index) => {
        pageDisable = true;
        loaderTime = true;
        // store.dispatch(successLoader(false));
        this.previewProxy(index);
    }
    onCloseProxyDocument = (index) => {
        pageDisable = true;
        loaderTime = true;
        // store.dispatch(successLoader(false));
        this.previewClosedProxy(index);
    }
    previewProxy = (index) => {
        let testAccess = Cookies.get('msAL_admin_dev');
        testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
        if (this.state.details[index]?.proxyDocument.split('/')[11]?.split("'")[0]?.split(".")[1] == "pdf") {
            var oReq = new XMLHttpRequest();
            // var URLToPDF = res.url;
            var URLToPDF = urlPath + this.state.details[index].proxyDocument;
            oReq.open("GET", URLToPDF, true);
            oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            oReq.responseType = "blob";
            oReq.onload = function () {
                // Once the file is downloaded, open a new window with the PDF
                // Remember to allow the POP-UPS in your browser
                const file = new Blob([oReq.response], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                pageDisable = false;
                loaderTime = false;
                // store.dispatch(successLoader(true));
                window.open(fileURL, "_blank");
            };
            oReq.send();
        }
        else {
            var xhr = new XMLHttpRequest();
            var URLToImage = urlPath + this.state.details[index]?.proxyDocument;
            // var URLToImage =urlPath+name;
            xhr.open("GET", URLToImage, true);
            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // xhr.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            // Ask for the result as an ArrayBuffer.
            xhr.responseType = "arraybuffer";
            xhr.onload = function (e) {
                // Obtain a blob: URL for the image data.
                var arrayBufferView = new Uint8Array(this.response);
                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                decodeProxyImage = imageUrl
                console.log("decode url", imageUrl);
                pageDisable = false;
                loaderTime = false;
                // store.dispatch(successLoader(true));
                hasOpenImagePreview = true;
            };
            xhr.send();
        }
    }
    onClosePreviewModal = () => {
        hasOpenImagePreview = false;
    }
    previewClosedProxy = (index) => {
        let testAccess = Cookies.get('msAL_admin_dev');
        testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
        if (this.state.detailsClosed1[index]?.proxyDocument.split('/')[11]?.split("'")[0]?.split(".")[1] == "pdf") {
            var oReq = new XMLHttpRequest();
            // var URLToPDF = res.url;
            var URLToPDF = urlPath + this.state.detailsClosed1[index].proxyDocument;
            oReq.open("GET", URLToPDF, true);
            oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            oReq.responseType = "blob";
            oReq.onload = function () {
                // Once the file is downloaded, open a new window with the PDF
                // Remember to allow the POP-UPS in your browser
                const file = new Blob([oReq.response], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                pageDisable = false;
                loaderTime = false;
                // store.dispatch(successLoader(true));
                window.open(fileURL, "_blank");
            };
            oReq.send();
        }
        else {
            var xhr = new XMLHttpRequest();
            var URLToImage = urlPath + this.state.detailsClosed1[index]?.proxyDocument;
            // var URLToImage =urlPath+name;
            xhr.open("GET", URLToImage, true);
            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // xhr.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            // Ask for the result as an ArrayBuffer.
            xhr.responseType = "arraybuffer";
            xhr.onload = function (e) {
                // Obtain a blob: URL for the image data.
                var arrayBufferView = new Uint8Array(this.response);
                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                decodeProxyImage = imageUrl
                console.log("decode url", imageUrl);
                pageDisable = false;
                loaderTime = false;
                // store.dispatch(successLoader(true));
                hasOpenImagePreview = true;
            };
            xhr.send();
        }
    }
    onClosePreviewModal = () => {
        hasOpenImagePreview = false;
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    onProxyDocumentAction = (index) => {
        ApiCall(
            'POST',
            workflowtxnAdmin + PROXYDOCUMENTACTION_ENDPOINT,
            {
                "action": this.state.action[index] == "Approve" ? "approve" : "reject",
                "proxyDocumentId": this.state.details[index].proxyDocumentId
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ confirmedHasOpen: true });
                }
            }
            else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="preacol1" className="tableHeading">Full Name</td>
                    <td id="preacol2" className="tableHeading">Mobile Number</td>
                    <td id="preacol3" className="tableHeading">Email Address</td>
                    <td id="preacol4" className="tableHeading">Shipping Line</td>
                    <td id="preacol5" className="tableHeading">Proxy Document</td>
                    <td id="preacol6" className="tableHeading">Submitted On</td>
                    <td id="preacol7" className="tableHeading" style={{ display: !viewOnly ? "none" : null }}>Action</td>
                    <td style={{ display: !viewOnly ? "none" : null }}></td>
                </tr>
            </>
        )
    }
    renderClosedTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="closedpartcol1" className="tableHeading">Full Name</td>
                    <td id="closedpartcol2" className="tableHeading">Mobile Number</td>
                    <td id="closedpartcol3" className="tableHeading">Email Address</td>
                    <td id="closedpartcol4" className="tableHeading">Shipping Line</td>
                    <td id="closedpartcol5" className="tableHeading">Proxy Document</td>
                    <td id="closedpartcol6" className="tableHeading">Acted On</td>
                    <td id="closedpartcol7" className="tableHeading">Status</td>
                    <td id="closedpartcol8" className="tableHeading" style={{ display: !viewOnly ? "none" : null }}></td>
                </tr>
            </>
        )
    }
    onSearchOpen() {
        this.setState({ filteredIndexOpen: [] }, () => {
            if (this.state.openSide == true) {
                if (this.state.searchlength > 0) {
                    this.state.details.filter((i, indexcloseds) => {
                        if (i.mobileNumber.toString().startsWith(this.state.search) == true) {
                            console.log('***')
                            let ic = this.state.filteredIndexOpen;
                            ic.push(indexcloseds);
                            this.setState({ filteredIndexOpen: ic }, () => {
                                console.log('inside closed indexfind', this.state.filteredIndexOpen)
                            })
                        }
                        // return i.mobileNumber.toString().includes(this.state.search)
                        return i.mobileNumber.toString().startsWith(this.state.search)
                    })
                }
                else {
                    this.setState({ filteredIndexOpen: this.state.details.map((x, i) => i) },
                        () => console.log(this.state.filteredIndexOpen, this.state.details.filter(i => i)))
                }
            }
        })
    }
    render() {
        if (this.state.closedSide == true) {
            if (this.state.searchlength > 0) {
                this.state.detailsClosed1 = this.state.detailsClosed.filter(i => i.mobileNumber?.toString().startsWith(this.state.search))
            }
            else {
                this.state.detailsClosed1 = this.state.detailsClosed;
            }
        }
        const { details, currentPage, todosPerPage } = this.state;
        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        const renderTableDatas = details.map((todo, index) => {
            const { fullName, mobileNumber, emailId, shippingLine, submittedOn } = todo;
            return (
                this.state.filteredIndexOpen.indexOf(index) != -1 &&
                <>
                    <tr key={index} id="preAdvisedata">
                        <td id="preAdvisecol1" className="tabledata">{fullName}</td>
                        <td id="preAdvisecol2" className="tabledata">{mobileNumber}</td>
                        <td id="preAdvisecol3" className="tabledata">{emailId}</td>
                        <td id="preAdvisecol4" className="tabledata">{shippingLine}</td>
                        <td id="preAdvisecol5" className="preview"><a onClick={() => this.onPreviewProxyDocument(index)}
                        >View</a></td>
                        <td id="preAdvisecol6" className="tabledata">{this.getDate(submittedOn)}</td>
                        <td id="preAdvisecol7" style={{ display: !viewOnly ? "none" : null }}>
                            <input type="text" className="inputpreAdviseActionDropdown"
                                readOnly
                                value={this.state.action[index]}
                                placeholder="- - Select - -" />
                            <img class="pl-2 mb-1"
                                id="actiondropdownArrow"
                                onClick={() => {
                                    let a = this.state.actiondropdown;
                                    a[index] = true;
                                    this.setState({ actiondropdown: a, actionIndex: index })
                                }}
                                src={arrow} alt="Second slide" />
                            {this.state.actiondropdown[index] &&
                                <div class="preAdviseActionDropdownOuter" >
                                    <div class="preAdviseActionDropdownOutline" ref={this.container} >
                                        {(this.ActionData.map((name, i) => {
                                            return (
                                                <table class='preAdviseActionDropdownData'  >
                                                    <td class="preAdviseActionDropdownRow"
                                                        onClick={(e) => this.selectAction(e, i, index, this.state.filteredIndexOpen[index])}
                                                    >
                                                        <small class="" id="actionData" >{name.name} </small>
                                                    </td>
                                                </table>
                                            );
                                        }))}
                                    </div>
                                </div>}
                        </td>
                        <td style={{ display: !viewOnly ? "none" : null }}>
                            <button id="preAdviseButtonCol"
                                disabled={!this.disabledConfirmed(index)}
                                onClick={() => this.onProxyDocumentAction(index)}
                            >
                                Confirm
                            </button>
                        </td>
                    </tr>
                </>
            )
        });
        const renderTableData = renderTableDatas.filter((data, ind) =>
            this.state.filteredIndexOpen.indexOf(ind) != -1
        ).slice(indexOfFirstTodo, indexOfLastTodo);
        console.log(indexOfFirstTodo, indexOfLastTodo);
        const totalPages = Math.ceil(this.state.filteredIndexOpen.length / this.state.todosPerPage);
        // const totalPages = Math.ceil(this.state.details.length / this.state.todosPerPage);
        console.log(totalPages, this.state.filteredIndexOpen.length, this.state.todosPerPage)
        const previousOff = this.state.currentPage == 1;
        const nextOff = this.state.currentPage == totalPages;
        const { detailsClosed1, currentClosedPage, todosClosedPerPage } = this.state;
        const indexOfLastClosedTodo = currentClosedPage * todosClosedPerPage;
        const indexOfFirstClosedTodo = indexOfLastClosedTodo - todosClosedPerPage;
        const renderClosedTableDatas = detailsClosed1.map((todo, index) => {
            return (
                <>
                    <tr key={index} id="preAdvisedata">
                        <td id="closedpartcol1" className="tabledata">{todo.fullName}</td>
                        <td id="closedpartcol2" className="tabledata">{todo.mobileNumber}</td>
                        <td id="closedpartcol3" className="tabledata">{todo.emailId}</td>
                        <td id="closedpartcol4" className="tabledata">{todo.shippingLine}</td>
                        <td id="closedpartcol5" className="preview"><Link
                            onClick={() => this.onCloseProxyDocument(index)}
                        >View</Link></td>
                        <td id="closedpartcol6" className="tabledata">{this.getDate(todo.submittedOn)}</td>
                        <td id="closedpartcol7" className="tabledata">{todo.action}</td>
                        <td id="closedpartcol8" className="tabledata" style={{ display: !viewOnly ? "none" : null }}>
                            {(todo.action === "Approved") && <button class="closepartbuttonrevored" onClick={() => this.onRevoke(index)}>Revoke</button>}
                        </td>
                    </tr>
                </>
            )
        });
        const renderClosedTableData = renderClosedTableDatas.slice(indexOfFirstClosedTodo, indexOfLastClosedTodo);
        const totalClosedPages = Math.ceil(this.state.detailsClosed1.length / this.state.todosClosedPerPage);
        const previousClosedOff = this.state.currentClosedPage == 1;
        const nextClosedOff = this.state.currentClosedPage == totalClosedPages;
        return (
            <div className="outer1" 
            id={pageDisable ? "disabletrue" : ""}
            ><div className="outer1" id="outerdiv">
                <MetaDecorator title={TitleDescription.preAdvisePageTitle} description={TitleDescription.preAdvisePageDescription} />
                <Loader
                    loaded={!loaderTime}
                    lines={10}
                    length={10}
                    width={10}
                    radius={10}
                    corners={1}
                    rotate={0}
                    direction={1}
                    color="#000"
                    speed={1}
                    trail={60}
                    shadow={false}
                    hwaccel={false}
                    className='spinner'
                    zIndex={2e9}
                    top="50%"
                    left="50%"
                    scale={1.0}
                    loadedClassName="loadedContent"
                />
                <div className="preAdviseContainer">
                    <SideNav />
                    <div id="preAdvicePart">
                        <h1 id='preAdvicetitle'>Pre-advise</h1>
                        {/* View Only Access */}
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <nav class="navbar navbar-light bg-white" id="openCloseNav">
                            <div>
                                <small class="p-2 pb-3" id="open" onClick={this.handleOpenSide}>Open</small>
                                <small class="p-2 pb-3" id="closed" onClick={this.handleClosedSide}>Closed</small>
                            </div>
                            <div>
                                <small id="searchBy">Search by</small>
                                <input
                                    className="mobileSearch"
                                    placeholder="Mobile Number"
                                    autoComplete="off"
                                    id="secrchInput"
                                    onChange={this.handlechange}
                                    value={this.state.search}
                                ></input>
                                <img id="search_img" src={require('../../../assets/images/search.svg')} width="16" height="16" />
                            </div>
                        </nav>
                        <div className="contentbox">
                            <table id='details'>
                                <tbody>
                                    {this.state.openSide ? this.renderTableHeader() : this.renderClosedTableHeader()}
                                    {this.state.openSide ? renderTableData : renderClosedTableData}
                                </tbody>
                            </table>
                            <hr width="100%" color="#BCBCBC" />
                            {this.state.openSide ?
                                <div className="paginationContainer">
                                    <button className={previousOff ? "previousbtnoff" : "previousbtnon"} onClick={this.handleOpenPrevious}>Previous</button>
                                    <small id="page">Page</small>
                                    <small id="currentpage">{this.state.currentPage}</small>
                                    <small id="of">of</small>
                                    <small id="totalpages">{totalPages}</small>
                                    <button className={nextOff ? "nextbtnoff" : "nextbtnon"} onClick={this.handleOpenClick}>Next</button>
                                </div>
                                :
                                <div className="paginationContainer">
                                    <button className={previousClosedOff ? "previousbtnoff" : "previousbtnon"} onClick={this.handleClosedPrevious}>Previous</button>
                                    <small id="page">Page</small>
                                    <small id="currentpage">{this.state.currentClosedPage}</small>
                                    <small id="of">of</small>
                                    <small id="totalpages">{totalClosedPages}</small>
                                    <button className={nextClosedOff ? "nextbtnoff" : "nextbtnon"} onClick={this.handleClosedClick}>Next</button>
                                </div>}
                        </div>
                    </div>
                </div>
                <DeleteModal hasOpen={this.state.hasOpenDelete} onClick={this.onCloseDeleteModal} onYesClick={this.confirmDelete} >
                    <p className="closedpartmodaldeletemodalText">Do you really want to revoke the user access
to Pre-advise for this shipping line?</p>
                </DeleteModal>
                {hasOpenImagePreview ?
                    <PreviewModal onClick={this.onClosePreviewModal}
                        profileData={decodeProxyImage}
                    /> : null}
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmedText">Confirmed</p>
                </SuccessModal>
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(PreAdvise);